export enum Mode {
  Development = 'development',
  Production = 'production',
}

export interface IBaseApiServiceParams {
  basePath?: string;
  className?: string;
  error?: boolean;
  mode?: Mode;
}

export interface IBaseApiService extends IBaseApiServiceParams {
  ERRORS?: Record<string, string>;

  sendRequest?: (
    path: string,
    params?: Record<string, any>,
    options?: RequestInit,
    object?: IFetchDataObjectBase
  ) => Promise<any>;
}

export interface IError {
  code: string;
  message: string;
}

export interface IFetchDataObjectBase {
  data?: any;
  delay?: number;
  method?: string;
  options?: Record<string, any>;
  timeout?: number;
}

export interface IFetchOptions {
  method?: RequestMethod;
  headers?: any;
  body?: any;
  mode?: "cors" | "no-cors" | "same-origin";
  credentials?: "omit" | "same-origin" | "include";
  cache?: "default" | "no-store" | "reload" | "no-cache" | "force-cache" | "only-if-cached";
  redirect?: "follow" | "error" | "manual";
  referrer?: string;
  referrerPolicy?: "referrer" | "no-referrer-when-downgrade" | "origin" | "origin-when-cross-origin" | "unsafe-url";
  integrity?: any;
}

export type InterceptorRequest = (
  params: Record<'method' | 'options' | 'optionsPure' | 'url', any>
) => Promise<any>;
export type InterceptorResponse = (
  params: Record<'data' | 'method' | 'response' | 'url', any>
) => Promise<any>;

export enum RequestMethod {
  CONNECT = 'CONNECT',
  DELETE = 'DELETE',
  GET = 'GET',
  HEAD = 'HEAD',
  OPTIONS = 'OPTIONS',
  PATCH = 'PATCH',
  POST = 'POST',
  PUT = 'PUT',
  TRACE = 'TRACE',
}

export type RequestMethodType = keyof typeof RequestMethod;